import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Modal, ModalBody, ModalFooter } from 'reactstrap';
import { bindActionCreators } from 'redux';
import { toastr } from 'react-redux-toastr';

import * as authActions from '../../actions/authActions';
import Messages from '../../components/common/Toastr/messages';
import EsqueciPwdForm from './Form';
import { getIPs } from '../../util/helper';

class Page extends Component {
    constructor(props) {
        super(props);
        this.state = {
            shouldShowModal: false,
            Private_IP: '0.0.0.0',
            Public_IP: '0.0.0.0',
            voltar: false,
            bgColor: this.props.options.bgColor || '#fff',
            textColor: this.props.options.textColor || '#000000',
            redirect: this.props.options.redirect || '/',
            boxTitle: this.props.options.boxTitle || '',
            bgColorBoxTitle: this.props.options.bgColorBoxTitle || '',
            textColorBoxTitle: this.props.options.textColorBoxTitle || '#000000',
        };
    }

    componentWillMount() {
        getIPs((ip) => {
            if (ip.match(/^(192\.168\.|169\.254\.|10\.|172\.(1[6-9]|2\d|3[01]))/)) {
                this.saveState('Private_IP', ip)
            } else {
                this.saveState('Public_IP', ip)
            }
        })
    }

    saveState(key, value) {
        this.setState({ [key]: value })
    }


    componentWillUnmount() {
        this.setState({ voltar: false, shouldShowModal: false, });
        this.props.actions.reset();

        this.saveState('browser', detectBrowser())
        this.saveState('textWhite', this.props.options.theme === 'admin' ? 'text-white' : '')
        this.saveState('bgColor', this.props.options.theme === 'admin' ? 'grey' : this.state.bgColor)
    }

    componentDidUpdate(prevProps, prevState) {

        if (this.props.validated) {
            toastr.error(this.props.validated);
            setTimeout(() => {
                document.location.href = '/';
            }, 2500)
        }
    }

    goBack = () => {
        this.setState({
            voltar: true
        });
    }

    onValidated = async (payload) => {
        await this.props.actions.esquecipwd(payload);
    }

    render() {
        const { options, className } = this.props;
        const { bgColorContainer, redirect } = options || {};
        const { voltar } = this.state;

        if (!!voltar) {
            return document.location.href = redirect;
        }

        return (
            <React.Fragment>

                <EsqueciPwdForm
                    title="Esqueci minha senha"
                    labels={{
                        login: "Digite seu usuário.",
                        cpf: "Digite seu CPF/CNPJ",
                    }}
                    sendButtonText="Recuperar minha senha"
                    className={className}
                    bgColorContainer={bgColorContainer}
                    onBack={this.voltar}
                    onValidated={this.onValidated}
                    bgColor={this.state.bgColor}
                    textColor={this.state.textColor}
                    redirect={this.state.redirect}
                    boxTitle={this.state.boxTitle}
                    bgColorBoxTitle={this.state.bgColorBoxTitle}
                    bgColorLogo={this.state.bgColorLogo}
                    textColorBoxTitle={this.state.textColorBoxTitle}
                    Private_IP={this.state.Private_IP}
                    Public_IP={this.state.Public_IP}
                />
                <Messages />
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => ({
    user: state.authreducer.user,
    validated: state.authreducer.validated
})

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(authActions, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(Page)
